"use client";

export default function GlobalError({ reset }: { reset: () => void }) {
  return (
    <html lang="es">
      <head>
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css2?family=Geist:wght@400;700&display=swap"
        />
      </head>
      <body
        style={{
          margin: 0,
          fontFamily: "Geist, system-ui, sans-serif",
          display: "flex",
          minHeight: "100vh",
          alignItems: "center",
          justifyContent: "center",
          padding: "0 1rem",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "1rem",
            textAlign: "center",
          }}
        >
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img
            src="/icon-512.png"
            alt="Pedile"
            width={64}
            height={64}
            style={{ borderRadius: "1rem" }}
          />
          <h1 style={{ fontSize: "1.5rem", fontWeight: 700, margin: 0 }}>
            Algo salió mal
          </h1>
          <p style={{ fontSize: "0.875rem", color: "#666", margin: 0 }}>
            Ocurrió un error inesperado. Podés intentar de nuevo.
          </p>
          <button
            onClick={reset}
            style={{
              padding: "0.5rem 1rem",
              fontSize: "0.875rem",
              fontWeight: 500,
              color: "#fff",
              backgroundColor: "#18181b",
              border: "none",
              borderRadius: "0.375rem",
              cursor: "pointer",
            }}
          >
            Reintentar
          </button>
          <a
            href="/"
            style={{
              fontSize: "0.875rem",
              color: "#18181b",
              textDecoration: "underline",
            }}
          >
            Volver al inicio
          </a>
        </div>
      </body>
    </html>
  );
}
